export const accountSettingsUrl = 'https://www.reddit.com/settings/account'
export const emailsSettingsUrl = 'https://www.reddit.com/settings/emails'
export const homeUrl = 'https://www.reddit.com'
export const messagingSettingsUrl = 'https://www.reddit.com/settings/messaging'
export const notificationsSettingsUrl =
  'https://www.reddit.com/settings/notifications'
export const privacySettingsUrl = 'https://www.reddit.com/settings/privacy'
export const profileSettingsUrl = 'https://www.reddit.com/settings/profile'
export const profileUrl = 'https://www.reddit.com/user/me'
export const appsUrl = 'https://www.reddit.com/prefs/apps'

// API urls
export const apiMeJsonUrl = 'https://www.reddit.com/api/me.json'
export const apiEditUserTextUrl = 'https://www.reddit.com/api/editusertext'
export const apiDeleteUrl = 'https://www.reddit.com/api/del'
export const apiGqlUrl = 'https://www.reddit.com/svc/shreddit/graphql'
